export const EMPTY_COUNTRY_CODE_OPTION = {
  value: "",
  label: "",
};
